import React from 'react';
import { isEmpty, cloneDeep, indexOf } from 'lodash';

import List from '@material-ui/core/List';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

import ACButton from '../../atoms/ACButton';
import SetClue from './SetClue';
import SetPOI from './SetPOI';
import Clue from './Clue';
import POIs from './POIs';

import styles from './Banks.module.scss';
import { getDefaultPOI } from '../../common/providers';
import { getDefaultClue } from '../../common/clues';
import { isLastMediaSame } from '../../common/global';
import { Button } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

const dummyCategoryName = 'Unsorted';
export default class Banks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModifyingClues: false,
      isModifyingPOI: false,
    };

    this.onOpenCluesModal = this.onOpenCluesModal.bind(this);
    this.onOpenPOIModal = this.onOpenPOIModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onClickClue = this.onClickClue.bind(this);
    this.onAddClue = this.onAddClue.bind(this);
    this.onClickPOI = this.onClickPOI.bind(this);
    this.onAddPOI = this.onAddPOI.bind(this);
    this.onSavePOI = this.onSavePOI.bind(this);

    this.onDeletePOI = this.onDeletePOI.bind(this);
  }

  onOpenCluesModal() {
    this.setState({ isModifyingClues: true });
  }

  onOpenPOIModal() {
    this.setState({ isModifyingPOI: true });
  }

  onCloseModal = () => {
    this.setState({
      isModifyingClues: false,
      isModifyingPOI: false,
    });
  };

  onClickClue(clue) {
    this.props.onSelectClueFunc(clue);
    this.onOpenCluesModal();
  }

  onAddClue() {
    this.props.onSelectClueFunc(getDefaultClue());
    this.onOpenCluesModal();
  }

  onClickPOI(poi) {
    this.props.onSelectPOIFunc(poi);
    this.onOpenPOIModal();
  }

  onSavePOI(newPoi) {
    if (isEmpty(newPoi)) return null;

    const { pois = [] } = cloneDeep(this.props);
    let isNew = false;

    if (newPoi.index >= 0) {
      isNew = false;
    } else {
      isNew = true;
    }

    const { media = { url: '' }, medias = [] } = newPoi;

    if (!isEmpty(media.url)) {
      if (!isLastMediaSame(medias, media)) medias.push(cloneDeep(media));
      delete newPoi.media;
      newPoi.medias = medias;
    }

    if (!isNew) {
      pois[newPoi.index] = cloneDeep(newPoi);
    } else {
      pois.push(cloneDeep(newPoi));
    }

    this.props.onSavePOIsFunc(pois);
  }

  onDeletePOI(deleteIndex) {
    const { pois ,storyboards} = cloneDeep(this.props);
    if (isEmpty(pois)) return null;
    const poi = pois[deleteIndex]
    let counter = 0;
    storyboards.forEach((storyboard)=>{
      const haveArray =storyboard?.pois?.filter((poiStoryboard)=>poiStoryboard.id === poi.id);
      if(!isEmpty(haveArray)){
        counter +=1;
      }
    })
    if(counter>0){
      window.alert("This POI is currently being used in a Storyboard.")
    }else{
      pois.splice(deleteIndex, 1);
      this.props.onSavePOIsFunc(pois);
    }
    this.onCloseModal();
  }

  onAddPOI() {
    this.props.onSelectPOIFunc(getDefaultPOI());
    this.onOpenPOIModal();
  }

  getCategories(pois) {
    let categories = [];

    if (!isEmpty(pois)) {
      pois.forEach((poi) => {
        if (!isEmpty(poi.category)) {
          if (indexOf(categories, poi.category) < 0) {
            categories.push(poi.category);
          }
        } else {
          // Make an unsorted category for all POIs that don't have a category.
          if (indexOf(categories, dummyCategoryName) < 0) {
            categories.push(dummyCategoryName);
          }
        }
      });
    }

    return categories;
  }

  renderClues(clues) {
    if (isEmpty(clues)) return;

    let cluesComponents = [];

    if (clues) {
      clues.forEach((clue) => {
        cluesComponents.push(<Clue clue={clue} onClickClueFunc={this.onClickClue} />);
      });
    }

    return cluesComponents;
  }

  render() {
    const clues = this.props.clues || [];
    const pois = this.props.pois || [];
    const categories = this.getCategories(pois);

    return (
      <div className={styles.root}>
        <div 
          style={{
            marginTop: '50px',
            display: 'none'
          }}>
          <div className={styles.title}>
            Available Clues
            <ACButton
              text={'Add'}
              icon={<AddCircleOutlineIcon />}
              iconLast={true}
              onClickFunc={this.onAddClue}
            />
          </div>

          <List className={styles.itemList}>{this.renderClues(clues)}</List>
        </div>

        <div
          style={{
            marginTop: '10px',
          }}
        >
          <div className={styles.title}>
            Building Blocks
          </div>
          <div className={styles.description}>
            Bank of nearby location recommendations and facts that you can stack on Storyboards       
          </div>
          <div style={{display: "flex",justifyContent: "end"}}>
             <Button
                variant="contained"
                style={{backgroundColor:'#FFE916', fontSize: '13px', color:"#434F69", boxShadow:"none", fontFamily: 'gilroy-regular'}}
                startIcon={<AddIcon />}
                onClick={this.onAddPOI}
            >
                Add New
            </Button>
          </div>
          {
            <POIs
              pois={pois}
              categories={categories}
              dummyCategoryName={dummyCategoryName} // Category name for places that do not have any category.
              providerId={this.props.providerId}
              onSavePOIsFunc={this.props.onSavePOIsFunc}
              onClickPOIFunc={this.onClickPOI}
              onDeletePOIFunc={this.onDeletePOI}
              showCategory={false}
            />
          }
        </div>

        <SetClue
          clue={this.props.clue}
          isModifying={this.state.isModifyingClues}
          onCloseFunc={this.onCloseModal}
          onSaveClueFunc={this.props.onSaveClueFunc}
          onUploadClueFunc={this.props.onUploadClueFunc}
          provider = {this.props.provider}
        />

        <SetPOI
          poi={this.props.poi}
          provider={this.props.provider}
          categories={categories}
          dummyCategoryName={dummyCategoryName}
          isModifying={this.state.isModifyingPOI}
          onCloseFunc={this.onCloseModal}
          onSavePOIFunc={this.onSavePOI}
          onDeletePOIFunc={this.onDeletePOI}
          onUploadPOIMediaFunc={this.props.onUploadPOIMediaFunc}
          onClearPOIMediaFunc={this.props.onClearPOIMediaFunc}
          media={this.props.poiMedia}
          uploadMediaFunc={this.props.uploadMediaFunc}
        />
      </div>
    );
  }
}
